module.exports = __webpack_public_path__ + "img/shop1-7.a05baf02.png";